import type { AggErrors } from '@atlassian/jira-software-roadmap-services/src/common/types.tsx';

export const isPermissionError = (errors: AggErrors): boolean =>
	errors.filter((error) => error.extensions?.statusCode === 403).length > 0;
